import request from '@/utils/zsm-requets'

const account='/zsm/api/account/'
 /**
  * 用户登录
  * @param id	账号
  * @param pwd	密码
  * @param token	令牌	query
  * @param securityMobile	密保手机号
  * @param onlineFlag	在线状态,1=在线，0=不在线
  */
export function accountLogin(params) {
  return request({
    url: account+'login',
    method: 'post',
    params
  })
}

// 用户登出
/* id	账号 */
export function accountLogout(id) {
  return request({
    url: account+'logout',
    method: 'post',
    params:{id}
  })
}

// 用户登出
/* id	账号 */
export function updatePwdAccount(params) {
  return request({
    url: account+'updatePwd',
    method: 'post',
    params
  })
}


// 修改密保手机号
/* code	验证码 */
/* id	账号 */
/* newMobile	新手机号 */

export function updateSecurityMobile( code,id,newMobile) {
  return request({
    url: account+'updateSecurityMobile',
    method: 'post',
    params:{
      code,id,newMobile
    }
  })
}



// 修改密码-根据老密码修改密码
/* code	验证码 */
/* newPwd	新密码
/* oldPwd	老手机号
*/
export function updatePwdByOldPwd( id,oldPwd,newPwd) {
  return request({
    url: account+'updatePwdByOldPwd',
    method: 'post',
    params:{
      id,oldPwd,newPwd
    }
  })
}


// 修改资料-个人的真实姓名
export function updateRealName( id,realName) {
  return request({
    url: account+'updateRealName',
    method: 'post',
    params:{
      id,realName
    }
  })
}



// 修改资料
/*
 companyCode//营业执照code
 companyName//公司名称
 id//账号
 */
export function updateCompanyInfo( id,companyCode,companyName) {
  return request({
    url: account+'updateCompanyInfo',
    method: 'post',
    params:{
      id,companyCode,companyName
    }
  })
}
